import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledModalWrapper = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	z-index: 5;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
	background-color: rgba(17, 19, 20, 0.85);
	opacity: 0;
	transition: opacity 0.3s ease;

	&.modal-enter {
		opacity: 0;
	}

	&.modal-enter-active,
	&.modal-enter-done,
	&.modal-exit {
		opacity: 1;
	}

	&.modal-exit-active {
		opacity: 0;
	}
`;

const StyledContainer = styled.div`
	width: 400px;
	padding: 30px;
	border: 1px solid rgba(255, 255, 255, 0.1);
	background-color: #111314;
	box-shadow: 0 6px 80px rgba(0, 0, 0, 0.75);
	border-radius: 10px;

	&::-webkit-scrollbar {
		display: none;
	}
`;

const StyledHeadContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;

	${Text} {
		font-weight: 500;
		font-size: 18px;
		color: #ffffff;
	}
`;

const StyledLevelsContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

const StyledLevelItem = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
	background-color: rgba(255, 255, 255, 0.02);
	border-radius: 5px;
	padding: 20px;

	& > ${Text} {
		font-weight: 400;
		font-size: 14px;
		color: #ffffff;
		opacity: 0.25;

		ul {
			list-style-type: initial;
			padding-left: 23px;
		}
	}
`;

const StyledLevelHead = styled.div<{ $isInactive?: boolean }>`
	display: flex;
	align-items: center;
	gap: 10px;

	& > ${Text} {
		&:nth-child(2) {
			font-weight: 500;
			font-size: 16px;
			color: #ffffff;
			flex: 1;
			opacity: ${(props) => (props.$isInactive ? 0.25 : 1)};
		}

		&:nth-child(3) {
			font-weight: 400;
			font-size: 14px;
			color: #ffffff;
			opacity: 0.25;
		}
	}
`;

const StyledCircle = styled.div<{
	$isNextLevel?: boolean;
	$isInactive?: boolean;
}>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 30px;
	height: 30px;
	background-color: ${(props) =>
		props.$isNextLevel
			? 'rgba(255, 255, 255, 0.05)'
			: props.$isInactive
			? 'rgba(255, 255, 255, 0.02)'
			: '#1782FF'};
	border-radius: 30px;
	border: 1px solid
		${(props) =>
			props.$isNextLevel
				? 'rgba(255, 255, 255, 0.1)'
				: props.$isInactive
				? 'rgba(255, 255, 255, 0.05)'
				: 'transparent'};

	${Text} {
		font-weight: 700;
		font-size: 18px;
		color: #ffffff;
		opacity: ${(props) => (props.$isInactive ? 0.25 : 1)};
	}
`;

export {
	StyledCircle,
	StyledContainer,
	StyledHeadContainer,
	StyledLevelHead,
	StyledLevelItem,
	StyledLevelsContainer,
	StyledModalWrapper,
};
